import { render, staticRenderFns } from "./The12306.vue?vue&type=template&id=1257f540"
import script from "./The12306.vue?vue&type=script&lang=js"
export * from "./The12306.vue?vue&type=script&lang=js"
import style0 from "./The12306.vue?vue&type=style&index=0&id=1257f540&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports